import { KeyValueBase } from "./interface";

export class OnBoardingStepDetailBase {
  title: string;
  description: string;
}

export class OnBoardingStepDetailName extends OnBoardingStepDetailBase { }

export class OnBoardingStepDetailPostalCode extends OnBoardingStepDetailBase { }

export class OnBoardingStepDetailBirthdate extends OnBoardingStepDetailBase { }

export class OnBoardingStepDetailGender extends OnBoardingStepDetailBase {
  genders: KeyValueBase[];
}

export class OnBoardingStepDetailAllergyAdditive extends OnBoardingStepDetailBase {
  alergies: OnBoardingAllergy[];
  additives: OnBoardingAdditive[];
}

export class OnBoardingStepDetailPreference extends OnBoardingStepDetailBase {
  preferences: OnBoardingPreference[];
}

export interface OnBoardingAllergy extends KeyValueBase {
  selected: boolean;
}

export interface OnBoardingAdditive extends KeyValueBase {
  selected: boolean;
}

export interface OnBoardingPreference extends KeyValueBase {
  selected: boolean;
}

export class OnBoardingData {
  name: string;
  postalCode: number;
  birthDate: Date;
  gender: number;
  allergies: KeyValueBase[];
  additives: KeyValueBase[];
  preferences: KeyValueBase[];
}

export class OnBoardingInfo {
  type: number;
  repeatation: number | null;
  routeList: string[] | null;
}

export class OnBoardingStepDetail {
  skipButton: string;
  templateNames: string[];
  StepDetailName: OnBoardingStepDetailName | null;
  StepDetailPostal: OnBoardingStepDetailPostalCode | null;
  StepDetailBirthday: OnBoardingStepDetailBirthdate | null;
  StepDetailGender: OnBoardingStepDetailGender | null;
  StepDetailAllergy: OnBoardingStepDetailAllergyAdditive | null;
  StepDetailPrefences: OnBoardingStepDetailPreference | null;
}
